import { ArrowPathIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedPoliceReportStatusChangedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityIcon,
  ActivityItem,
  ActivityStatusTransition,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';
import { formatStatus } from '../activity-feed-v2/utils';

export interface PoliceReportStatusChangedEventProps {
  event: DiscriminatedPoliceReportStatusChangedEvent;
}

export const PoliceReportStatusChangedEvent: React.FC<
  PoliceReportStatusChangedEventProps
> = ({ event }) => {
  const { police_report, old_report_status, new_report_status } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-red-100">
          <ArrowPathIcon className="h-4 w-4 text-red-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <div className="flex items-center gap-3">
        {police_report?.report_identifier && (
          <ActivityTitle>{police_report.report_identifier}</ActivityTitle>
        )}
        {old_report_status && new_report_status && (
          <ActivityStatusTransition
            from={formatStatus(old_report_status)}
            to={formatStatus(new_report_status)}
          />
        )}
      </div>
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Police Report Status Changed"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
